'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _dateFns = require('date-fns');

var _type = require('../type');

var _type2 = _interopRequireDefault(_type);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var format = function format(value) {
  return value ? (0, _dateFns.format)((0, _dateFns.isDate)(value) ? value : (0, _dateFns.parse)(value), 'M.D.YY') : '';
};

var validate = function validate(value) {
  return /^\d{1,2}\.\d{1,2}\.\d{2}$/.test(value);
};

exports.default = (0, _type2.default)({
  type: 'date',
  format: format,
  validate: validate
});